<template>
  <div class="post-item">
    <span v-if="page == 1">
      <span v-if="index == 0" class="item-index top1">{{ index + 1 }}</span>
      <span v-else-if="index == 1" class="item-index top2">{{
        index + 1
      }}</span>
      <span v-else-if="index == 2" class="item-index top3">{{
        index + 1
      }}</span>
      <span v-else class="item-index">{{ index + 1 }}</span>
    </span>
    <span v-else class="item-index">
      {{ index + 11 }}
    </span>
    <!-- <a :href="'/detail/'+hotDataList.id">{{ hotDataList.title }}</a> -->
    <a @click="toDetail(hotDataList.id)">{{ hotDataList.title }}</a>
  </div>
</template>

<script>
export default {
  name: "hotPost",
  props: ["hotDataList", "index", "page"],
  data() {
    return {};
  },
  methods: {
    toDetail(id) {
      let currPath = this.$route.path;
      if (currPath.indexOf(id) < 0) {
        // this.$router.push("/detail/" + id + "/0");
        let routeData = this.$router.resolve("/detail/" + id + "/0")
        window.open(routeData.href, '_blank')
      }
    },
  },
};
</script>

<style scoped lang="scss">
.post-item {
  padding: 10px 20px;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .item-index {
    display: inline-block;
    margin-right: 8px;
    color: #333;
    border-radius: 2px;
    width: 19px;
    height: 19px;
    text-align: center;
    line-height: 19px;
    span {
      color: #317DFF;
    }
    &.top1 {
      background: #F23531;
      color: #fff;
    }
    &.top2 {
      background: #fb6f6c;
      color: #fff;
    }
    &.top3 {
      background: #f98537;
      color: #fff;
    }
  }
  a {
    color: #121212;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HotPost.vue